<template>
  <transition>
    <div v-if="isShow" name="modal">
          <div class="modal-mask">
              <div class="modal-wrapper" @click="ok">
                <div id="content" v-on:click.stop="">
                  <div>
                    <font-awesome-icon class="check-circle" icon="check-circle"/>
                    <p class="modal-text">{{ message }}</p>
                  </div>
                  <div class="ok-button" @click="ok">OK</div>
                  <span class="chancel-button" @click="ok">
                    <font-awesome-icon  icon="times"/>
                  </span>
                </div>
              </div>
          </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

/**
 * @deprecated
 */
@Component
export default class SuccessModal extends Vue {
  private message?: string;

  private isShow: boolean = false;

  /**
   * 成功モーダルを表示
   * @param {string} message 表示する文言
   */
  open(message: string = 'Success !') {
    this.message = message || this.message
    this.isShow = true
  }

  /**
   * モーダルを閉じる
   */
  close() {
    this.isShow = false
  }

  /**
   * OKボタンのハンドリング
   */
  private ok() {
    this.$emit('ok')
    this.close()
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

#content{
  z-index:2;
  width:25%;
  text-align: center;
  padding: 2em;
  margin: 0 auto;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ok-button {
  background: #1cc8a0;
  border:3px solid #1cc8a0;
  color: #fff;
  padding:10px 20px;
  border-radius: 30px;
  display: block;
  width: 100px;
  margin:auto;
  cursor: pointer;
  user-select:none;
}

.ok-button:hover {
  background:#fff;
  color: #1cc8a0;
}

.chancel-button {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.chancel-button:hover {
  opacity:.5;
}

.check-circle {
  color: #92D050;
  font-size: 75px;
  display: block;
  margin: auto;
  margin-bottom : 20px;
}

.modal-text {
  font-size: 20px;
  margin-bottom:60px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
